import { Marker } from '../services/marker.service';
import { TYC_AGREEMENT_KEY } from './constants';

export function determineWorkOrderStatus(workOrderMetaData: Marker): string {
  return workOrderMetaData?.job_status ?? 'invalid';
}

export function checkForServiceAgreement(): boolean {
  try {
    const stored = localStorage.getItem(TYC_AGREEMENT_KEY);

    if (!stored) return false;

    const hasAgreed = JSON.parse(stored);
    return hasAgreed === true;
  } catch (e) {
    console.log('[HELPER CHECK FOR SERVICE AGREEMENT]: Error ', e);
    return false;
  }
}

export function validJobId(jobId: string | null): boolean {
  if (!jobId) {
    return false;
  }

  const VALID_LENGTH = [15, 18];
  const SA_IDENTIFIER = '08p'; 

  return (
    jobId.startsWith(SA_IDENTIFIER) && VALID_LENGTH.includes(jobId.length)
  );
}
